<template>

    <div class="progress-monitor-step-1">

        <b-form-group label="Who is the student that will be the focus of the plan?">
            <b-form-input type="text" required
                          v-model="docData.studentName"/>
        </b-form-group>
        <b-form-group label="What is the student’s school or district?">
            <b-form-input type="text" required
                          v-model="docData.schoolName"/>
        </b-form-group>
        <b-form-group label="Who is the adult creating this data-collection plan?">
            <b-form-input type="text" required
                          v-model="docData.adultName"/>
        </b-form-group>
        <b-form-group label="What is today's date?">
            <b-form-input type="date" required
                          v-model="docData.todayDate"/>
        </b-form-group>
        <b-form-group label="Who will be collecting the actual data for this plan?">
            <b-form-input type="text" required
                          v-model="docData.collectorName"/>
        </b-form-group>
        <b-form-group>
            <label>
                In 1 to 2 sentences, describe the "intervention target" (academic or behavioral problem or deficit)
                to be monitored in this plan:
            </label>
            <b-form-textarea required
                          v-model="docData.interventionTarget"/>
        </b-form-group>

    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'

    export default Vue.extend({
        name: "ProgressMonitorStep1",
        mixins: [ToolMixin],
        computed: {
            thisStepIsValid() {
                return this.docData.studentName
                    && this.docData.schoolName
                    && this.docData.adultName
                    && this.docData.todayDate
                    && this.docData.collectorName
                    && this.docData.interventionTarget
            }
        },
    })

</script>


